<template>
  <!-- 路由页面主体 -->
  <router-view />

  <!-- 全局登录弹窗（任意页面都能弹出，解决输入权限路由空白无弹窗问题） -->
  <UserLogin 
    :show="authStore.showLoginModal" 
    @close="authStore.closeLoginModal"
    @loginSuccess="handleLoginSuccess"
  />

  <!-- 开屏广告弹窗（层级高于页面） -->
  <HomeSplashAd 
    v-if="showSplashAd" 
    @close="handleAdClose"
  />
</template>

<script setup>
import { ref, onMounted, nextTick, watch } from 'vue';
import { useRouter } from 'vue-router';
// 全局状态、组件导入
import { authStore } from '@/authStore.js';
import UserLogin from '@/components/User-Login.vue';
import HomeSplashAd from '@/components/Home-SplashAd.vue';

const router = useRouter();

// 开屏广告逻辑
const hasShownSplashAd = localStorage.getItem('hasShownSplashAd');
const showSplashAd = ref(false);

// 监听广告弹窗状态，动态控制页面滚动
watch(showSplashAd, (val) => {
  if (val) {
    document.body.classList.add('ad-open');
    document.body.classList.remove('ad-closed');
  } else {
    document.body.classList.remove('ad-open');
    document.body.classList.add('ad-closed');
  }
}, { immediate: true });

onMounted(async () => {
  // 全局捕获未处理Promise错误，不阻断业务
  window.addEventListener('unhandledrejection', (event) => {
    event.preventDefault();
    const error = event.reason;
    console.log('===== 全局捕获异步错误 =====');
    console.log('错误信息:', error.message);
    console.log('错误堆栈:', error.stack);
  });

  // 未展示过广告则弹出
  if (!hasShownSplashAd) {
    await nextTick();
    showSplashAd.value = true;
  }
});

// 关闭广告，永久标记已展示
const handleAdClose = () => {
  showSplashAd.value = false;
  localStorage.setItem('hasShownSplashAd', 'true');
};

// 登录成功回调：跳转到需要权限的详情页
const handleLoginSuccess = () => {
  router.replace('/detail');
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html, body {
  width: 100%;
  height: 100%;
}
/* 广告打开时禁止滚动穿透 */
body.ad-open {
  overflow: hidden;
}
/* 广告关闭恢复页面滚动 */
body.ad-closed {
  overflow: auto;
}
</style>